import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import {
  IntelligenceSettingsActions,
  IntelligenceSettingsSelectors,
} from '@core/intelligence-data';
import { AnyIntelligenceSettings } from '@core/intelligence-types';

@Injectable({ providedIn: 'root' })
export class IntelligenceSettingsDataService {
  private readonly store = inject(Store);
  private readonly settingsState$ = this.store.select(IntelligenceSettingsSelectors.state);

  public readonly settingsState = this.store.selectSignal(IntelligenceSettingsSelectors.state);
  public settingsLoaded$ = this.settingsState$.pipe(map(state => state.loaded));

  public toggleAiFeature<T extends AnyIntelligenceSettings['field']>(key: T, value: boolean) {
    this.store.dispatch(IntelligenceSettingsActions.toggleFeature({ payload: { [key]: value } }));
  }

  public getFeatureState<K extends AnyIntelligenceSettings['feature']>(feature: K) {
    return this.settingsState$.pipe(
      map(state => state.data),
      filterBoolean,
      map(
        data =>
          <Extract<AnyIntelligenceSettings, { feature: K }>>(
            data.find(setting => setting.feature === feature)!
          ),
      ),
    );
  }

  public load() {
    this.store.dispatch(IntelligenceSettingsActions.fetch());
  }

  public fetchIfNotLoaded() {
    const { pending, loaded } = this.settingsState();
    if (loaded || pending) return;

    this.load();
  }
}
